/*----------------------
   SECTION TEXT HOVER
---------------------- */

hoverVideo = {
    init: function () {
        $(".text-hover__text a[href^='#']").on('mouseenter', function () {
            var key = $(this).attr('href').replace('#', '');
            var popup = $(`#${key}`);

            popup.addClass('active');
            $('.text-popup-bg').addClass('active');

            if (popup.find('video').length > 0) {
                popup.find('video').get(0).play();
            }

        }).on('mouseleave', function () {
            var key = $(this).attr('href').replace('#', '');
            var popup = $(`#${key}`);

            popup.removeClass('active');
            $('.text-popup-bg').removeClass('active');

            if (popup.find('video').length > 0) {
                $(this).find('video').get(0).pause();
            }
        });

        $(".text-hover__media-popup").on('mouseenter', function () {
            $(this).addClass('active');
            $('.text-popup-bg').addClass('active');
            var id = $(this).attr('id');
            $(`a[href="#${id}"]`).addClass('hover');

        }).on('mouseleave', function () {

            $(this).removeClass('active');

            $('.text-popup-bg').removeClass('active');
            var id = $(this).attr('id');
            $(`a[href="#${id}"]`).removeClass('hover');

            if (popup.find('video').length > 0) {
                $(this).find('video').get(0).pause();
            }
        });
    }
};


$(function () {
    hoverVideo.init();
});